module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h4', {
    staticClass: "card-title text-left mt-2"
  }, [_vm._v("Mode de jeu : plateaux")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("TODO préciser les règles du jeu un peu ? TODO Et renvoyer vers la création des plateaux ")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title text-left mt-2"
  }, [_vm._v("Plateaux disponibles")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label-cols-sm": "3",
      "label": "Filtre"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Recherchez par joueur, mot, difficulté..."
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Effacer")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label-cols-sm": "3",
      "label": "Par page"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.pageOptions
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "fields": _vm.fields,
      "items": _vm.boards_filtered,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "busy": _vm.isBusy,
      "stacked": "md",
      "striped": ""
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.index + 1) + "\n      ")]
      }
    }, {
      key: "difficulty",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(_vm.format_difficulty(data.value)) + "\n      ")]
      }
    }, {
      key: "createdAt",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.value) + "\n      ")]
      }
    }, {
      key: "word",
      fn: function(data) {
        return [(_vm.is_player(data)) ? _c('span', [_vm._v(_vm._s(data.item.word_variants[0]))]) : _vm._e()]
      }
    }, {
      key: "word_variants",
      fn: function(data) {
        return [(_vm.is_player(data)) ? _c('b-button', {
          staticClass: "mr-1 p-1",
          attrs: {
            "size": "sm",
            "variant": "outline-secondary"
          },
          on: {
            "click": data.toggleDetails
          }
        }, [_vm._v("\n          " + _vm._s(data.detailsShowing ? 'Masquer' : 'Voir les variantes') + "\n        ")]) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(data) {
        return [_c('b-card', [_c('b-row', {
          staticClass: "mb-2"
        }, [_c('b-col', [_c('b-list-group', _vm._l((data.item.word_variants), function(word, key, index) {
          return _c('b-list-group-item', {
            key: index,
            staticClass: "p-2"
          }, [_vm._v("\n                  " + _vm._s(word) + "\n                ")])
        }), 1)], 1), _vm._v(" "), _c('b-col', [_c('b-form', [_c('b-input-group', [_c('b-form-input', {
          attrs: {
            "placeholder": "Synonymes, variante orthographique..."
          },
          model: {
            value: (_vm.word_variant),
            callback: function($$v) {
              _vm.word_variant = $$v
            },
            expression: "word_variant"
          }
        }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
          attrs: {
            "type": "submit"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.addVariant(data.index, data.item)
            }
          }
        }, [_vm._v("Ajouter une variante")])], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "players",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.value.length) + "\n      ")]
      }
    }, {
      key: "scores",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "mr-1 p-1",
          attrs: {
            "size": "sm",
            "variant": "outline-secondary"
          },
          on: {
            "click": function($event) {
              return this.alert('TODO lancer le Hall of Fame')
            }
          }
        }, [_vm._v("\n          Voir les scores\n        ")])]
      }
    }, {
      key: "play",
      fn: function(data) {
        return [(!_vm.is_player(data)) ? _c('b-button', {
          staticClass: "mr-1 p-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'Playboard',
                params: {
                  boardId: data.item._id
                }
              })
            }
          }
        }, [_vm._v("\n          Jouer\n        ")]) : _vm._e()]
      }
    }])
  }, [_c('div', {
    staticClass: "text-center text-danger my-2",
    attrs: {
      "slot": "table-busy"
    },
    slot: "table-busy"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  }), _vm._v(" "), _c('strong', [_vm._v("Chargement en cours...")])], 1)]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d389ae","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/boards.vue
// module id = 74iA
// module chunks = 1